export const SIZE = 2;
export const HALF_SIZE = SIZE / 2;
export const NODES_IN_COUPLE = 2;
